__turbopack_context__.v({
  "demo": "demo-module__HQHt2q__demo",
  "row": "demo-module__HQHt2q__row",
  "rowInner": "demo-module__HQHt2q__rowInner",
});
